import React, { useMemo } from 'react';
import { Typography } from 'fronton-react';
import { cx } from 'linaria';
import { cn } from 'utils/classnames';
import { ProductDiscountPercent } from 'common/components/product-price-view/product-discount-percent';
import {
  oldPriceCrossed,
  container,
  oldPriceWrap,
  oldCurrencyWrap,
  padLeft,
  padRight,
  newOldPriceStyle,
  specialPriceContainer,
  bestPriceStyle,
  specialOldPriceWrap,
  bestPriceMarker,
  oldNewPriceMarker,
  oldPriceWrapper,
} from './styles';
import { ProductBestPriceNameplate } from './product-best-price-nameplate';
import { mainPriceReviewsClass, primaryPriceFractCurrencyReviewsClass } from './common-styles';

type ProductOldNewPriceProps = {
  hintShown?: boolean;
  currency: string;
  priceFirst: string;
  priceSecond?: string | null;
  rawOldPrice: string;
  hasOldPrice: boolean;
  hasBestPrice: boolean;
  uom?: string;
  discountPercent?: number;
};

export const ProductSpecialPrice: React.FC<ProductOldNewPriceProps> = ({
  uom,
  priceFirst,
  priceSecond,
  rawOldPrice,
  currency,
  hasOldPrice,
  hasBestPrice,
  discountPercent,
}) => {
  const oldPrice = useMemo(() => {
    return rawOldPrice.slice(0, rawOldPrice.indexOf('₽'));
  }, [rawOldPrice]);

  const formattedOldPriceString = useMemo(
    () => (oldPrice.slice(-4) === ',00\u00A0' ? `${oldPrice.slice(0, -4)}\u00A0` : oldPrice),
    [oldPrice],
  );

  const priceFirstWithComma = `${priceFirst},`;
  const specialPriceColor = hasBestPrice && bestPriceStyle;

  return (
    <div
      data-qa={hasBestPrice ? 'product-best-price' : 'product-old-new-price'}
      className={cn(container, hasBestPrice ? bestPriceMarker : oldNewPriceMarker)}
    >
      {hasBestPrice && <ProductBestPriceNameplate />}
      {hasOldPrice && (
        <div className={oldPriceWrapper}>
          {!hasBestPrice && <ProductDiscountPercent percent={discountPercent} />}
          <div className={oldPriceCrossed}>
            <Typography variant="s" size="body_accent" className={oldPriceWrap}>
              {formattedOldPriceString}
            </Typography>
            <Typography variant="s" size="body_accent" className={oldCurrencyWrap}>
              {currency}
            </Typography>
          </div>
        </div>
      )}
      <div className={specialOldPriceWrap}>
        <div className={cx(specialPriceContainer, hasOldPrice && !hasBestPrice && newOldPriceStyle)}>
          <span
            className={cx(mainPriceReviewsClass, specialPriceColor)}
            data-qa={hasBestPrice ? 'best-price-main' : 'new-price-main'}
          >
            {priceSecond ? priceFirstWithComma : priceFirst}
          </span>
          {priceSecond && (
            <span
              className={cx(primaryPriceFractCurrencyReviewsClass, specialPriceColor, padLeft)}
              data-qa={hasBestPrice ? 'best-price-fract' : 'new-price-fract'}
            >
              {priceSecond}
            </span>
          )}
          <span className={cx(primaryPriceFractCurrencyReviewsClass, specialPriceColor, padRight, padLeft)}>
            {`${currency}${uom ? `/${uom}` : ''}`}
          </span>
        </div>
      </div>
    </div>
  );
};
